import React, { ButtonHTMLAttributes, PropsWithChildren } from 'react';
import styled from 'styled-components';

export interface IContainer {
  show?: boolean;
}

export interface IAlign {
  alignCenter?: boolean;
}

const StyledContainer = styled.div<IContainer>`
  height: 100%;
  width: 100%;

  background-color: rgba(0, 0, 0, 0.3);
  top: 0;
  left: 0;
  position: fixed;
  overflow: overlay;
  z-index: 999;
  display: ${(p) => (p.show ? 'flex' : 'none')};
  flex: 1;
  justify-content: center;
  align-items: center;
`;

export const Container = ({
  children,
  ...props
}: PropsWithChildren<IContainer>): JSX.Element => {
  return React.createElement(StyledContainer, props, children);
};

const MessageText = styled.span<IAlign>`
  font-size: 1em;
  font-weight: 700;
  text-align: ${(p) => (p.alignCenter ? 'center' : 'left')};
  color: ${({ theme: { colors } }) => colors.primary};
`;

export const Message = ({
  children,
  ...props
}: PropsWithChildren<IAlign>): JSX.Element => {
  return React.createElement(MessageText, props, children);
};

export const Divider = styled.div<IContainer>`
  height: 1px;
  width: 100%;
  margin-top: 25px;
`;

export const DividerLine = styled.div<IContainer>`
  height: 1px;
  width: 100%;
  margin-top: 35px;
  background-color: rgba(0, 0, 0, 0.1);
`;

export const Icon = styled.img`
  align-self: start;
  height: 40px;
  object-fit: contain;
`;

type CloseIconProps = ButtonHTMLAttributes<HTMLButtonElement>;

export const CloseIcon = styled.button<CloseIconProps>`
  cursor: pointer;
  float: right;
  border: 0;
  padding: 0;
  background: transparent;
`;

export const TitleHeader = styled.span`
  text-align: center;
  flex: 1;
  font-size: 1.1rem;
  font-weight: 700;
  color: ${({ theme: { colors } }) => colors.primary};
`;
